import { Popconfirm } from 'antd';
import React from 'react';
// import PropTypes from 'prop-types';

export default function PopconfirmOptions(props) {
  const { okText, cancelText, title, onConfirm, innerEle,onCancel, width,height,disabled } = props;
  return (
      <Popconfirm
        title={title}
        onConfirm={onConfirm}
        okText={okText || "Yes"}
        cancelText={cancelText || "No"}
        placement="left"
        onCancel={onCancel}
        overlayClassName='manage-subs-popconfirm-options'
        overlayStyle={{ width: width || '200px', height: height || 'auto' }}
        disabled={disabled || false}
      >
        {innerEle}
      </Popconfirm>
  );
};

PopconfirmOptions.propTypes = {};
PopconfirmOptions.defaultProps = {};
